// extracted by mini-css-extract-plugin
export var content = "stickyNav-module--content--bfc6d";
export var wrapper = "stickyNav-module--wrapper--72bcd";